// import library
import { useContext } from "react";
// import context
import { AuthContext } from "../../context";
import { NavLink } from "react-router-dom";
import { env } from "../../env";

const AuthIndex = () => {
    // variable
    const authContext = useContext(AuthContext);
    const logoUrl = env.REACT_APP_LOGO_URL;

    return (
        // <div className="bg-yellow-normal p-10 relative h-[35rem] md:h-screen">
        //     {/* logo */}
        //     { authContext.loginPageLogo
        //         ? <img alt="logo" className="w-32 h-32" src={`data:image/png;base64,`+ authContext.loginPageLogo} />
        //         : null
        //     }
        //     {/* map logo*/}
        //     <div className="absolute transform -translate-y-1/2 -translate-x-1/2 top-2/4 left-2/4">
        //         { authContext.loginPageBackgroundImage
        //             ? <img alt="background-logo" src={`data:image/png;base64,`+ authContext.loginPageBackgroundImage} />
        //             : null
        //         }
        //     </div>
        // </div>
        <div className="flex flex-col items-center justify-center">
            { authContext.loginPageLogo
                ?
                  (logoUrl ? <NavLink to={logoUrl} target="_blank"><img className="h-24 aspect-video" src={`data:image/png;base64,`+ authContext.loginPageLogo} alt="logo" /></NavLink> : <img className="h-24 aspect-video" src={`data:image/png;base64,`+ authContext.loginPageLogo} alt="logo" />)
                : null
            }
        </div>
    )
}

export default AuthIndex;